import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FAQ = () => {
  const [openItems, setOpenItems] = useState(new Set([0])); // First item open by default

  const faqData = [
    {
      question: "What is the difference between Event Styling and Event Planning?",
      answer: `While related, they are distinct services. Event Planning covers the logistical aspects—timelines, budgets, vendor management, and coordination. \n\nOur Event Decor & Styling service is purely aesthetic. We focus on the visual narrative of your event: creating a cohesive theme, designing floral installations, curating furniture, and orchestrating the overall atmosphere.`
    },
    {
      question: "How does your design and decor process work?",
      answer: `Our process is collaborative and begins with understanding your unique story and style. It typically follows these steps:\n\n• Discovery & Vision: We dive deep into your inspiration and desired atmosphere.\n• Concept & Mood Board: We create a visual proposal with color palettes, textures, and key design elements.\n• Curation & Sourcing: We source all necessary elements, from bespoke furniture to custom floral arrangements.\n• Execution & Installation: Our team flawlessly executes the design on the day of the event.`
    },
    {
      question: "Can you source specific high-end furniture or build custom installations?",
      answer: `Absolutely. This is a core part of our Premium Rentals & Event Logistics service. We have an extensive network of luxury rental partners and the capability to commission custom-built pieces, such as unique backdrops, arches, or branded installations, to make your event truly one-of-a-kind.`
    },
    {
      question: "What types of corporate or VIP events do you specialize in?",
      answer: `We specialize in creating sophisticated, high-impact experiences. Our expertise includes luxury brand activations, exclusive product launches, high-profile charity galas, and intimate influencer events. We focus on creating an environment that reflects brand prestige and delivers a seamless guest experience.`
    },
    {
      question: "How far in advance should we book your decor or logistics services?",
      answer: `For comprehensive event decor, we recommend booking 6-9 months in advance to allow ample time for design and sourcing. For large-scale logistics and premium rentals, booking as early as possible is ideal, especially if custom fabrications are required. However, we can often accommodate shorter timelines based on our schedule.`
    },
    {
      question: "Do you travel for destination events?",
      answer: `Yes, our design and logistics teams are available for destination events both within Kenya and internationally. We have extensive experience managing the complexities of sourcing and execution in new locations to ensure a flawless and beautiful result, no matter where your event takes place.`
    }
  ];

  const toggleItem = (index) => {
    const newOpenItems = new Set(openItems);
    if (newOpenItems.has(index)) {
      newOpenItems.delete(index);
    } else {
      newOpenItems.add(index);
    }
    setOpenItems(newOpenItems);
  };

  return (
    // The component assumes it's placed on a page with a non-solid background (image or gradient) for the glass effect to be visible.
    <div>
      <div className="text-center mb-12">
        <h2 className="font-heading text-3xl font-bold text-white mb-4">
          Your Questions, Answered
        </h2>
        <p className="font-body text-white/70 max-w-2xl mx-auto">
          Insights into our process, capabilities, and how we bring extraordinary events to life.
        </p>
      </div>

      {/* --- THIS IS THE NEW DARK GLASSMORPHIC DESIGN --- */}
      <div className="space-y-4 max-w-4xl mx-auto">
        {faqData.map((item, index) => (
          <div
            key={index}
            // This container is now a glass panel
            className="rounded-2xl border border-white/10 bg-gray-900/20 backdrop-blur-lg transition-all duration-300"
          >
            <button
              onClick={() => toggleItem(index)}
              className="w-full p-6 text-left flex items-center justify-between"
              aria-expanded={openItems.has(index)}
            >
              <h3 className="font-body font-semibold text-lg text-white pr-4">
                {item.question}
              </h3>
              <Icon
                name="ChevronDown"
                size={20}
                className={`text-white/50 transition-transform duration-300 flex-shrink-0 ${
                  openItems.has(index) ? 'rotate-180' : ''
                }`}
              />
            </button>
            
            {/* The answer panel appears smoothly within the glass */}
            {openItems.has(index) && (
              <div className="px-6 pb-6">
                <p className="font-body text-white/70 whitespace-pre-line pt-4 border-t border-white/10">
                  {item.answer}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="mt-16 text-center max-w-2xl mx-auto">
        <div className="p-8 rounded-2xl border border-white/10 bg-gray-900/20 backdrop-blur-lg">
            <Icon name="HelpCircle" size={32} className="text-primary mx-auto mb-4" />
            <h3 className="font-heading text-xl font-bold text-white mb-2">
              Have a Different Question?
            </h3>
            <p className="font-body text-white/70 mb-6">
              Our team is ready to provide detailed answers for your specific event. Let's start the conversation.
            </p>
            <Button
                variant="default"
                size="lg"
                onClick={() => window.location.href = '/contact'}
                className="w-full sm:w-auto"
                iconName="MessageSquare"
                iconPosition="left"
              >
                Contact Our Team
              </Button>
        </div>
      </div>
    </div>
  );
};

export default FAQ;